var _line, _line2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparatorPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 44,
    viewBox: "0 0 336 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.37114e-8,
    y1: 15.5,
    x2: 143,
    y2: 15.5,
    stroke: "#F88DA4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 193,
    y1: 15.5,
    x2: 336,
    y2: 15.5,
    stroke: "#F88DA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.282 16.3387L166.874 23.606L172.131 28.7687L181.034 20.0347C182.062 19.0007 182.631 17.622 182.631 16.148C182.631 14.674 182.062 13.2953 181.034 12.2613C179.707 10.934 177.804 10.3913 175.996 10.7947C176.061 11.1687 176.105 11.55 176.105 11.9387C176.098 13.596 175.449 15.1653 174.282 16.3387Z",
    fill: "#F88DA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.869 24.552L173.772 15.818C174.8 14.784 175.369 13.398 175.369 11.9313C175.369 11.484 175.31 11.044 175.208 10.626C175.208 10.6187 175.201 10.6187 175.201 10.6113C175.201 10.604 175.201 10.5967 175.201 10.5893C174.96 9.636 174.479 8.756 173.772 8.03734C171.643 5.896 168.172 5.896 166.035 8.03734L165.131 8.94667C164.985 9.09334 164.759 9.09334 164.614 8.94667L163.709 8.03734C162.645 6.96667 161.245 6.43134 159.845 6.43134C158.445 6.43134 157.045 6.96667 155.98 8.03734C154.945 9.07867 154.376 10.4573 154.376 11.924C154.376 13.3907 154.945 14.7767 155.98 15.8107L164.869 24.552Z",
    fill: "#F88DA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorPink);
export default __webpack_public_path__ + "static/media/separator-pink.1e9fc794558556dd991a32033ad0693b.svg";
export { ForwardRef as ReactComponent };